import { Check } from 'lucide-react';

/**
 * Numbered setup-step header. Steps are derived from live state so the header
 * doubles as a progress indicator; clicking a step scrolls to its section.
 *
 * steps: [{ id, label, state: 'done' | 'current' | 'todo' }]
 */
export default function WizardSteps({ steps, onSelect }) {
  return (
    <ol className="flex flex-wrap gap-2">
      {steps.map((step, index) => {
        const done = step.state === 'done';
        const current = step.state === 'current';
        return (
          <li key={step.id} className="flex items-center">
            <button
              type="button"
              onClick={() => onSelect?.(step.id)}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-full border text-sm transition-colors ${
                done
                  ? 'border-green-200 bg-green-50 text-green-700 dark:border-green-800 dark:bg-green-900/30 dark:text-green-300'
                  : current
                    ? 'border-primary-300 bg-primary-50 text-primary-700 dark:border-primary-700 dark:bg-primary-900/30 dark:text-primary-300'
                    : 'border-neutral-200 bg-white text-neutral-500 dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-400'
              }`}
            >
              <span
                className={`flex h-5 w-5 items-center justify-center rounded-full text-xs font-semibold ${
                  done
                    ? 'bg-green-600 text-white'
                    : current
                      ? 'bg-primary-600 text-white'
                      : 'bg-neutral-200 text-neutral-600 dark:bg-neutral-700 dark:text-neutral-300'
                }`}
              >
                {done ? <Check className="h-3 w-3" /> : index + 1}
              </span>
              <span className="font-medium">{step.label}</span>
            </button>
            {index < steps.length - 1 && (
              <span className="mx-1 hidden text-neutral-300 dark:text-neutral-600 sm:inline">›</span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
